import SolicitacaoBolsa from './componentes/SolicitacaoBolsa.vue';
import SolicitacaoBolsaLista from './componentes/SolicitacaoBolsaLista.vue';
import SolicitacaoBolsaForm from './componentes/SolicitacaoBolsaForm.vue';
import SolicitacaoBolsaRelatorio from './componentes/SolicitacaoBolsaRelatorio.vue';

export default {
  path: '/solicitacao-bolsa',
  component: SolicitacaoBolsa,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoBolsaLista,
      name: 'solicitacao-bolsa',
    },
    {
      path: 'nova',
      component: SolicitacaoBolsaForm,
      name: 'solicitacao-bolsa.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoBolsaRelatorio,
      name: 'solicitacao-bolsa.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoBolsaForm,
      name: 'solicitacao-bolsa.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-bolsa/rotas.js